
import { Stack, Typography } from '@mui/material';
import React from 'react';

import { PageType } from './BillingPage.types';
import { getPageProps } from './pagesUtils';


const BillingPages = ({ pageType }: { pageType: PageType }) => {
  const { message, element } = getPageProps(pageType);
  return (
    <Stack
      height='100dvh'
      width='100dvw'
      justifyContent='center'
      alignItems='center'
    >
      {element}
      <Typography fontSize={28} fontWeight={700}>{message}</Typography>
    </Stack>
  );
};

export default BillingPages;
